// extracted by mini-css-extract-plugin
export var chip = "_rx-0";
export var icon = "_rx-1";
export var remove = "_rx-2";
export var removeIcon = "_rx-3";